import { notificationConstant } from "./notification.constant";

export const getNotification = (responseData) => async (dispatch) => {
  if (responseData) {
    dispatch({
      type: notificationConstant.GET_NOTIFICATION_SUCCESS,
      data: responseData,
    });
  } else {
    dispatch({
      type: notificationConstant.GET_NOTIFICATION_FAILURE,
      data: "",
    });
  }
};
